import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'StatisticsView',
  setup(__props) {

const router = useRouter();

const navigate = (path: string) => {
  router.push(path);
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pt-16 card-list" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate('/statistics/quizzes')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("h2", null, "Quiz Of The Day", -1),
              _createElementVNode("p", null, [
                _createTextVNode(" Number of quiz "),
                _createElementVNode("i", null, "started"),
                _createTextVNode(" versus "),
                _createElementVNode("i", null, "finished"),
                _createTextVNode(" over the last 30 days per category ")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (navigate('/statistics/actions')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("h2", null, "Actions", -1),
              _createElementVNode("p", null, "Number of actions added, completed per day", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (navigate('/statistics/co2-scan')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("h2", null, "CO₂ Footprint scans", -1),
              _createElementVNode("p", null, "User counts per footprint", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-8 bg-primary card",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (navigate('/statistics/user-interests')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("h2", null, "Users", -1),
              _createElementVNode("p", null, "User statistics", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})